/* eslint-disable */

// react
import React, {useEffect, useState} from "react";

//MUI
import { Box, Divider, Stack, Grid, Button} from "@mui/material";
import UTextField from "../../components/mui/UTextField";
import UTable from "../../components/mui/UTable";

// API
import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI} from "../../services/commonService";


// 230330 이재형 :: Data Grid > Table 테스트
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { makeStyles } from "@material-ui/core/styles";
import { theme } from '../../assets/themes';



//거래집계상세 그리드 Grouping
const columnGroupingModel_Detail = [

    // Bill
    {
        groupId: 'bill',
        headerName: 'Bill',
        description: '',
        children: [{ field: 'billTotal' }, { field: 'bill_100' }, { field: 'bill_50' }, { field: 'bill_20' }, { field: 'bill_10' },
                    { field: 'bill_5' },{ field: 'bill_2' },{ field: 'bill_1' },
        ],
        align: "center",
        headerAlign: "center"
    },
    // Coin
    {
        groupId: 'coin',
        headerName: 'Coin',
        description: '',
        children: [{ field: 'coinTotal' }, { field: 'coin_100' }, { field: 'coin_50' }, { field: 'coin_20' }, { field: 'coin_10' },
                    { field: 'coin_5' },{ field: 'coin_1' },
        ],
        align: "center",
        headerAlign: "center"
    },
];

export default function TotalDetailPopup(props) {

    const data = props.data;

    //거래집계 & 상세 Grid 표시 데이터
    const [gridDataDetail, setGridDataDetail] = useState([]);

    const columns = [
        {
            field: 'Date',
            headerName: '일시',
            width: 150,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"1",
            // hide: true,
            valueFormatter: (params)=>{
                if (params.rows.IOKndCd == "01" || params.rows.IOKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"red"}}>
                    {params.value}</div>;
                }
            }
        },
        {
            field: 'MachineID',
            headerName: '기기번호',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"2",
            hide: true,
        },
        {
            field: 'transType',
            headerName: '거래유형',
            width: 150,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"3",
            valueFormatter: (params)=>{
                if (params.rows.IOKndCd == "01" || params.rows.IOKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"red"}}>
                    {params.value}</div>;
                }
            }
        },
        {
            field: 'total',
            headerName: '총합계',
            width: 80,
            editable: false,
            align: "right",
            headerAlign: "center",
            id:"4",
            valueFormatter: (params)=>{
                if (params.rows.IOKndCd == "01" || params.rows.IOKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"flex-end", color:"red"}}>
                    {params.value}</div>;
                }
            }
        },
        {
            field: 'bill',
            headerName: '지폐',
            width: 350,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"5",
            colSpan: [
                {
                    parentField: "bill",
                    field: 'bill_100',
                    headerName: '$100',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_50',
                    headerName: '$50',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_20',
                    headerName: '$20',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_10',
                    headerName: '$10',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_5',
                    headerName: '$5',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_2',
                    headerName: '$2',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "bill",
                    field: 'bill_1',
                    headerName: '$1',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        {
            field: 'coin',
            headerName: '동전',
            width: 350,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"6",
            colSpan: [
                {
                    parentField: "coin",
                    field: 'coin_100',
                    headerName: '100¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "coin",
                    field: 'coin_50',
                    headerName: '50¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "coin",
                    field: 'coin_25',
                    headerName: '25¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "coin",
                    field: 'coin_10',
                    headerName: '10¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "coin",
                    field: 'coin_5',
                    headerName: '5¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    parentField: "coin",
                    field: 'coin_1',
                    headerName: '1¢',
                    width: 50,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        {
            field: 'check',
            headerName: '수표',
            width: 50,
            editable: false,
            align: "right",
            headerAlign: "center",
            id:"7",
        },
    ];

    const useStyles = makeStyles({
        table: {
            "& .MuiTableCell-root": {
                border: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
            }
        },
        header:{
            fontWeight:"bold",
            "& .MuiTableCell-root": {
                // width:195,
            }
        },
        cellTitle:{
            backgroundColor:theme.custom.appbarBgColor,            
        },
        cell:{
            padding:5
        }
    });
    const classes = useStyles();


    //화면 로드 시
    useEffect(() => {
        const getLoadData = async() => {
            try {
                await getGridDataDetail();        //거래집계 상세
            } catch (e) {
            }
        };
        getLoadData();
        // console.log(data);
    }, [data]);

    //화면들어올때 자동조회 - 거래집계상세
    const getGridDataDetail = async() => {
        setGridDataDetail([]);
        // console.log("@@@ 거래집계상세 @@@");
        //검색조건
        // let data = {
        //     storeCd:    search.storeCd ? search.storeCd : "",               //지점코드
        //     startDate:  search.startDate ? search.startDate : "20230101",   //시작날짜
        //     endDate:    search.endDate ? search.endDate : now,              //종료날짜
        //     machId:     search.machine ? search.machine : "",               //기번
        //     trans:      search.trans ? search.trans : "",                   //거래타입
        //     ioType:     search.io ? search.io : "",                         //입출금타입
        // };
        // console.log(data);
        const res = await getAPI(API.TRANS.TOTAL_DETAIL,data);

        const inputData = res.data.result.map((rowData) => ({
                //no
                id:rowData.no,

                //거래날짜
                Date:rowData.tranDate,

                //지점명
                branchName:rowData.storeNm,

                //기번
                MachineID:rowData.machId,

                //거래타입
                transType:rowData.trnskndnm,

                //입출금
                IO:rowData.ioKndNm,

                //입출금코드
                IOKndCd:rowData.ioKndCd,

                //합계 subtotal
                total:"$ "+rowData.total.toLocaleString("en-US"),

                //권종별 매수
                //BILL
                bill_100:rowData.bill100Cnt,
                bill_50:rowData.bill50Cnt,
                bill_20:rowData.bill20Cnt,
                bill_10:rowData.bill10Cnt,
                bill_5:rowData.bill5Cnt,
                bill_2:rowData.bill2Cnt,
                bill_1:rowData.bill1Cnt,

                //COIN
                coin_100:rowData.coin100Cnt,
                coin_50:rowData.coin50Cnt,
                coin_25:rowData.coin25Cnt,
                coin_10:rowData.coin10Cnt,
                coin_5:rowData.coin5Cnt,
                coin_1:rowData.coin1Cnt,

                //CHECK
                check:"$ "+rowData.etc.toLocaleString("en-US")
            })
        );
        // console.log(inputData);
        setGridDataDetail(inputData);
    }
    const dateFormmater = (yyyymmdd) => {
        let date = yyyymmdd;
        if (yyyymmdd.length > 7) {
            const year = yyyymmdd.substring(0,4)
            const month = yyyymmdd.substring(4,6)
            const day = yyyymmdd.substring(6,8)
            date = year + "-" + month + "-" + day
        }
        return date;
    }
    const startDate = dateFormmater(data.startDate);

    return (
    <div className="pop-container">
        <div className="contents">
            <Box>
                <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title" >{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 점번선택 */}
                                <UTextField id="branch" name="storeCd" defaultValue={data.branchName} disabled={true}/>
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 브랜드선택 */}
                                <UTextField id="brand" name="brand" defaultValue={data.brandNm} disabled={true}/>
                            </TableCell>
                            <TableCell className="table-cell-title" >{fni18n('일자')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 날짜선택 */}
                                <UTextField id="date" name="date" defaultValue={data.startDate} disabled={true}/>
                            </TableCell>
                            <TableCell className="table-cell"> </TableCell>
                            <TableCell className="table-cell"> </TableCell>
                           
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
                <div className="search"></div>
            </Box>

            <UTable columns={columns} rows={gridDataDetail} />

        </div>
    </div>
    );
}